import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { FramedElementKeyType, FramedService } from '../services/framed-service';

@Directive({
    selector: '[framed]', // 👈 must match what you use in the template!
})
export class FramedDirective {
    @Input('framed') key: FramedElementKeyType;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private framedService: FramedService
    ) {}

    ngOnInit() {
        const shouldHide = this.framedService.isHidden(this.key);
        if (shouldHide) {
            this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        }
    }
}
